// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { MonNumberService } from '@monsido/core/locale/services/mon-number.service';

@Pipe({
    name: 'monNumber',
    standalone: false,
})
export class MonNumberPipe implements PipeTransform {
    constructor (private monNumberService: MonNumberService) {}
    transform (value: any, format: string = ''): string {
        if (!format) {
            return this.monNumberService.transformNumber(value);
        }
        if (format.toString().length < 2) {
            return this.monNumberService.transformNumber(value, `0,0`);
        }
        return this.monNumberService.transformNumber(value, format);
    }
}
